import { all, put, call, takeLeading } from "redux-saga/effects";
import { callApi, callSsoApi } from "../../../common/util/api";
import { makeFetchSaga } from "../../../common/util/fetch";
import { actions, Types } from "./index";

function* fetchLogin({ email, password }) {
  const { isSuccess, data } = yield call(callSsoApi, {
    url: "/auth/login",
    data: { email, password },
  });
  if (isSuccess) {
    yield put(actions.fetchUser());
  }
}

function* fetchLogout() {
  yield call(callSsoApi, { url: "/auth/logout" });
  yield put(actions.setUser(null));
}

function* fetchUser() {
  const { isSuccess, data } = yield call(callApi, { url: "/auth/user" });
  if (isSuccess && data !== null) {
    yield put(actions.setUser(data));
    return;
  }
  if (isSuccess && data === null) {
    const { isSuccess: refreshed } = yield call(callSsoApi, { url: "/auth/token/refresh" });
    if (refreshed) {
      const { isSuccess: retrySuccess, data: retryData } = yield call(callApi, { url: "/auth/user" });
      if (retrySuccess) {
        yield put(actions.setUser(retryData));
        return;
      }
    }
  }
  yield put(actions.setUser(null));
}

function* fetchEmail({ payload }) {
  yield call(callSsoApi, {
    url: "/auth/signup",
    data: { ...payload, service: "BLOG" },
  });
}

function* fetchVerifyEmail({ token }) {
  const { isSuccess } = yield call(callSsoApi, {
    url: "/auth/signup/verify",
    data: { token },
  });
  if (isSuccess) {
    yield put(actions.fetchUser());
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function* () {
  yield all([
    takeLeading(Types.FetchLogin, makeFetchSaga({ fetchSaga: fetchLogin, canCache: false })),
    takeLeading(Types.FetchUser, makeFetchSaga({ fetchSaga: fetchUser, canCache: false })),
    takeLeading(Types.FetchLogout, makeFetchSaga({ fetchSaga: fetchLogout, canCache: false })),
    takeLeading(Types.FetchEmail, makeFetchSaga({ fetchSaga: fetchEmail, canCache: false })),
    takeLeading(Types.FetchVerifyEmail, makeFetchSaga({ fetchSaga: fetchVerifyEmail, canCache: false })),
  ]);
}
